import { useUsersAll } from "@/entities/users/hooks";
import { useMemo } from "react";

export const useStoreInitializer = () => {
  const { isLoading: loadingUsers } = useUsersAll();
  // const { isLoading: loadingThresholds } = useThresholds();
  // const { isLoading: loadingCompanies } = useAllCompanies();
  // const { isLoading: loadingPeople } = useAllPeople();
  // const { isLoading: loadingDeals } = useAllDeals();
  // const { isLoading: loadingLeads } = useAllLeads();

  return useMemo(
    () => ({
      isLoading: loadingUsers /* ||
        loadingThresholds ||
        loadingCompanies ||
        loadingPeople ||
        loadingDeals ||
        loadingLeads*/
    }),
    [
      loadingUsers
      // loadingThresholds,
      // loadingCompanies,
      // loadingPeople,
      // loadingDeals,
      // loadingLeads,
    ]
  );
};

const StoreInitializer: React.FC = () => {
  useStoreInitializer();
  return null;
};

export default StoreInitializer;
